'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _surveyFilter = require('./survey-filter.html');

var _surveyFilter2 = _interopRequireDefault(_surveyFilter);

var _surveyFilter3 = require('./survey-filter.controller');

var _surveyFilter4 = _interopRequireDefault(_surveyFilter3);

require('./survey-filter.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var surveyFilterComponent = {
  restrict: 'E',
  bindings: {
    applyFilters: '&'
  },
  template: _surveyFilter2.default,
  controller: _surveyFilter4.default,
  controllerAs: 'vm'
};

exports.default = surveyFilterComponent;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/survey-filter/survey-filter.component.js
 **/